import React, { useState, useEffect } from 'react';
import NumericKeypad from '../common/NumericKeypad';

const QuantityModal = ({ item, onConfirm, onClose }) => {
  const [quantity, setQuantity] = useState('');
  const [error, setError] = useState('');
  const [replaceOnNext, setReplaceOnNext] = useState(false);

  useEffect(() => {
    if (item) {
      setQuantity(String(item.quantity ?? 0));
      setError('');
      setReplaceOnNext(true);
    }
  }, [item]);

  if (!item) return null;

  const handleSave = () => {
    const parsed = Number(quantity);
    if (Number.isNaN(parsed) || parsed < 0) {
      setError('Enter a valid number (0 or higher).');
      return;
    }
    const itemKey = item.lineId || item.productId;
    onConfirm(itemKey, parsed);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm max-h-[calc(100vh-2rem)] overflow-y-auto p-4 sm:p-6 flex flex-col gap-4">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">Update quantity</h3>
          <p className="text-sm text-slate-600">{item.name}</p>
        </div>
        <div className="text-center py-3">
          <p className="text-sm uppercase text-slate-500 tracking-wide">Quantity</p>
          <p
            className={`text-4xl font-bold text-slate-900 inline-block px-4 py-1 rounded-xl ${
              replaceOnNext ? 'ring-2 ring-primary/50 bg-primary/10' : ''
            }`}
          >
            {quantity || '0'}
          </p>
          {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
        </div>
        <NumericKeypad
          value={quantity}
          onChange={(next) => {
            setQuantity(next);
            if (error) setError('');
          }}
          allowDecimal={false}
          replaceOnNext={replaceOnNext}
          onReplaceHandled={() => setReplaceOnNext(false)}
        />
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-xl border border-slate-300 py-3 font-semibold text-slate-700 hover:bg-slate-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="flex-1 rounded-xl bg-primary text-white py-3 font-semibold hover:bg-primary/90"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuantityModal;
